import React from "react";
import { Box, SxProps } from "@mui/material";
import colors from "../../themes/colors";

export interface CustomChipProps {
  value?: string;
  sx?: SxProps;
}

export const CustomChip = ({ value, sx }: CustomChipProps) => {
  return (
    <Box
      className="text-14-medium"
      sx={{
        background: colors.secondary.gray96,
        color: colors.secondary.gray20,
        borderRadius: "4px",
        width: "fit-content",
        padding: "4px 8px",
        ...sx
      }}
    >
      {value}
    </Box>
  );
};
